import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LabelMode } from 'devextreme/common';
import { CtlBysDetayService } from './ctl-bys-detay.service';
import { DxButtonModule, DxPopupModule, DxScrollViewModule, DxToastModule } from 'devextreme-angular';
import { CtlSablonComponent } from '../ctl-sablon/ctl-sablon.component';
import { CtlBysDetayAramaComponent } from './ctl-bys-detay-arama/ctl-bys-detay-arama.component';
import { UtilsService } from '../../../services/utils.service';
import { OrtakService } from '../../../services/ortak.service';

@Component({
  selector: 'dk-ctl-bys-detay',
  standalone: true,
  imports: [CommonModule,
     DxButtonModule,
     CommonModule,
     DxPopupModule,
     DxScrollViewModule,
     DxToastModule,
    CtlSablonComponent,
    CtlBysDetayAramaComponent
  ],
    providers:[CtlBysDetayService],
  templateUrl: './ctl-bys-detay.component.html',
  styleUrls: ['./ctl-bys-detay.component.scss'],
})
export class CtlBysDetayComponent implements OnInit,OnChanges {
  @Input() labelText = "";
  @Input() labelMode:LabelMode = null;
  public crudPopupVisible = false;
  public toastMessage: string;
  public toastVisible = false;
  public showAction = true;
  public title!: string;
  @Input() isReadOnly = false;
  public data: any;public isFirst = true;
  public control!: any;
  controlName = "BysBelgeDetay";
  @Input() code!: any;
  @Input() isBindCheck = false;
  @Input() warningMessage: string | null = null;
  @Output() public dataResult: EventEmitter<any> = new EventEmitter();

  constructor(private service: CtlBysDetayService, private utilsService: UtilsService, private ortakService: OrtakService) {}

  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isReadOnly'] || changes['isBindCheck']) {
      this.service.setParams(this.isReadOnly, this.isBindCheck)
    }
  }

  ngOnInit(): void {
    if (this.controlName) {
      this.getControl();
    }
    this.service.setParams(this.isReadOnly, this.isBindCheck)
  }
  getControl(){
    this.ortakService.getControl(this.controlName)
    .subscribe((data) => {
      this.control = data?.controlMetadata;
             //this.service.getDlist(this.control?.dlistCode);
      this.service._gridControlsList.next(data?.controlMetadata.dlistMetadata)
      //if(this.labelText === "")this.labelText = this.control.controlDescription;
        if(data?.controlMetadata.dlistMetadata.baseEntity){
          if(this.labelText === "")this.labelText = this.control.controlDescription;
          if(this.code && this.control) this.getData(this.code,true)
if(this.isFirst) this.isFirst = false;;
        }
    });
  }

  searchClick() {
    if(this.showAction) this.crudPopupVisible = true
    else this.toastVisible = true
  }

  clear() {
    this.title = '';
    this.code = null;
    this.data = null;
    this.dataResult.emit(null);
  }

  handleValueChange(e: any) {
    if(this.showAction){
      if (e === '' || e === null) this.clear();
      else if(!this.isFirst) this.getData(e);
    this.isFirst = false;
    }
    else this.toastVisible = true
  }

  getData(code: number, isSetData?: boolean) {

    this.data = this.service.getData(code,this.control,this.control.dlistMetadata.baseEntity,isSetData);
    this.data.load().done((result: any) => {
      if (result.length > 0) {
        this.title = result[0].BelgeAd;
        this.code = result[0].BelgeKod;
        this.dataResult.emit(result[0]);
      } else if (this.code.length > 0) {
        this.utilsService.showError('Bulunamadı');
        this.clear();
      }
    });

  }

  closePopupAfter(result: any, sablonCmp: CtlSablonComponent) {
    if (result?.data) {
      this.data = result.data;
      this.code = result.data.BelgeKod;
      this.dataResult.emit(this.data);
    }
    this.crudPopupVisible = false;
    setTimeout(() => {
      sablonCmp.focusInput();
    });
  }
}
